module.exports = __webpack_public_path__ + "img/qitaimg.6a48ac76.png";